import * as THREE from 'three'

import Mediator from './globals/mediator'

import config from './config'

let emitter = Mediator.emitter

import camera from './modules/camera'

import scene from './scene'

import PostProcessing from './modules/postprocessing'

import renderer from './renderer'

import Trail from './modules/trail/'

let post = true

import FBOHELPER from './globals/fbohelper'

import {

	FBO_DEBUG

} from './globals/constants'

let pixelBuffer =  new Uint8Array( 4 )
let divPick = 4

export default class World3D {

	constructor(){

		this.initScene()

		this.initObjects()

        this.addEvents()

        this.mouse = {
        	x : 0,
        	y: 0
        }

        this.offset = {

        	x: 0,
        	y: 0
        }

        Mediator.onResize()

	}

	initScene() {

	    this.container = config.container

	    this.scene = scene

	    this.renderer = renderer

	    this.camera = camera

	    this.renderer.setSize(window.innerWidth , window.innerHeight)

	    this.canvas = this.renderer.domElement

	    this.container.appendChild( this.canvas )

	    this.posteffect = new PostProcessing(this.scene, this.camera, this.renderer )

	    this.pickingTexture = new THREE.WebGLRenderTarget( window.innerWidth / divPick, window.innerHeight / divPick );

	    this.pickingTexture.texture.minFilter = THREE.LinearFilter;

	    this.pickingTexture.texture.generateMipmaps = false;


	    if(FBO_DEBUG){ 

	    	FBOHELPER.attach(this.pickingTexture, 'picking')
	    }
	
	}

	initObjects(){

		this.trail = new Trail()

		scene.add(this.trail)

	}

	mousemove(e) {

		this.mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
		this.mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;

		this.offset.x = event.clientX / divPick
		this.offset.y = event.clientY / divPick

		emitter.emit('picking', true)

		renderer.setRenderTarget(this.pickingTexture)

		renderer.render( scene, camera);

		renderer.readRenderTargetPixels(this.pickingTexture, this.offset.x, this.pickingTexture.height - this.offset.y, 1, 1, pixelBuffer);

		if(pixelBuffer[3] == 255){

			emitter.emit('raycasted', pixelBuffer[0] / 255)
		}


		emitter.emit('picking', false)

	}

	update(){

	    this.renderer.render(this.scene, this.camera)
	}


	posteffectupdate() {

	    this.posteffect.render(this.scene, this.camera)

	}


	addEvents() {

	    if(post == false){

	    	this.updateEvent = this.update.bind(this)

	    }

	    else{

	    	this.updateEvent = this.posteffectupdate.bind(this)
	    }

	    emitter.on('update', this.updateEvent)

	    emitter.on('mousemove', this.mousemove.bind(this))

	    emitter.on('resize', this.resize.bind(this))
	   
	}

	resize(w, h) {

	    this.w = w

	    this.h = h

	    this.renderer.setSize( this.w , this.h  );

	    this.pickingTexture.setSize(this.w / divPick, this.h / divPick)

	}
}


// WEBPACK FOOTER //
// ./src/scripts/Trail/world3D.js